<template>
  <nav
    class="flex items-center justify-between w-full"
    :class="{ 'stopGeoloc--alone': showStopGeoloc && !showGoBackMap && !previousRoute.name}"
  >
    <router-link
      v-if="previousRoute.name"
      id="label-previousStep"
      class="--no-style"
      :to="{ name: previousRoute.name }"
    >
      <IconWrap
        class="mr-2"
        label="previousStep"
        width="16"
        height="16"
      >
        <IconArrowBack />
      </IconWrap>
      {{ $t('layout.navigation.previous') }}
    </router-link>

    <router-link
      v-if="showGoBackMap"
      id="label-showMap"
      class="--no-style"
      :to="getPathFromName($route.matched[0].meta.firstChildName || $route.matched[0].name)"
    >
      <IconWrap
        class="mr-2"
        label="showMap"
        width="16"
        height="16"
      >
        <IconArrowBack />
      </IconWrap>
      {{ $t('pages.visitImage.showMap') }}
    </router-link>

    <router-link
      v-if="showStopGeoloc"
      class="--no-style"
      :to="'/contribute/' + $route.params.imageId"
    >
      {{ $t('pages.geolocalise.stopGeoloc') }}
    </router-link>
  </nav>
</template>

<script>
import IconArrowBack from '@/assets/images/icons/ArrowBack';
import IconWrap from '@/assets/images/icons';

export default {
  name: 'NavSplitMain',

  components: {
    IconWrap,
    IconArrowBack
  },

  props: {
    previousRoute: {
      type: Object,
      default: () => ({ name: null })
    },

    showStopGeoloc: {
      type: Boolean,
      default: () => false
    },

    showGoBackMap: {
      type: Boolean,
      default: () => false
    }
  },

  methods: {
    getPathFromName(name) {
      return this.$router.resolve({ name }).path;
    }
  }
};
</script>

<style lang="postcss" scoped>
a{
  @apply flex items-center px-4 text-gray-300 no-underline;
  & svg{
    @apply text-gray-300;
  }
  &:hover, &:hover svg{
    @apply text-gray-500;
  }
}

nav.stopGeoloc--alone{
  @apply justify-end;
}
</style>
